import { render, staticRenderFns } from "./REAIQueue.vue?vue&type=template&id=71761792&scoped=true"
import script from "./REAIQueue.vue?vue&type=script&lang=js"
export * from "./REAIQueue.vue?vue&type=script&lang=js"
import style0 from "./REAIQueue.vue?vue&type=style&index=0&id=71761792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71761792",
  null
  
)

export default component.exports